import React from 'react';
import { Steps } from 'antd';
import type { StepsProps } from 'antd';

// First, ensure StepsProps['items'] is not undefined
type AntdStepItem = NonNullable<StepsProps['items']>[number];
// Extend with your custom `content` field
type CustomStepItem = AntdStepItem & {
    content?: React.ReactNode;
};

type StepsComponentProps = {
    current?: number;
    items: CustomStepItem[];
    className?: string;
    children?: React.ReactNode;
};

const StepsComponent = ({
    className = '',
    current = 0,
    items = [],
    ...props
}: StepsComponentProps) => {
    return (
        <Steps current={current} items={items} {...props}>
            {props?.children}
        </Steps>
    );
};

export default StepsComponent;
